var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2118 13.5426L9.84007 14.9143C8.6685 16.0859 8.6685 17.9854 9.84007 19.157C11.0116 20.3285 12.9111 20.3285 14.0827 19.157L15.9111 17.3285C17.0827 16.157 17.0827 14.2575 15.9111 13.0859C15.6632 12.838 15.3827 12.6425 15.0833 12.4995L14.4969 13.0859C14.4359 13.1469 14.3845 13.2138 14.3426 13.2847C14.658 13.3751 14.9556 13.5445 15.204 13.793C15.9851 14.5741 15.9851 15.8404 15.204 16.6214L13.3756 18.4499C12.5946 19.2309 11.3282 19.2309 10.5472 18.4499C9.76613 17.6688 9.76613 16.4025 10.5472 15.6214L11.3398 14.8288C11.2276 14.4087 11.1849 13.9739 11.2118 13.5426Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0827 11.6717C11.9111 12.8433 11.9111 14.7428 13.0827 15.9143C13.3306 16.1623 13.6112 16.3577 13.9105 16.5007L14.6861 15.7251C14.3578 15.6374 14.0474 15.4648 13.7898 15.2072C13.0088 14.4262 13.0088 13.1598 13.7898 12.3788L15.6182 10.5504C16.3993 9.76931 17.6656 9.76931 18.4467 10.5504C19.2277 11.3314 19.2277 12.5977 18.4467 13.3788L17.6541 14.1714C17.7663 14.5915 17.8089 15.0264 17.782 15.4577L19.1538 14.0859C20.3254 12.9143 20.3254 11.0148 19.1538 9.84326C17.9822 8.67168 16.0827 8.67168 14.9111 9.84326L13.0827 11.6717Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLink);
export default __webpack_public_path__ + "static/media/ActionLink.2621b196930e744dddc46ddc609b8a2c.svg";
export { ForwardRef as ReactComponent };